export const resolveSectionProducts = (section, allProducts = [], options = {}) => {
    if (!section) return [];
    
    const source = String(section.source || 'recommended').toLowerCase();
    const manualIds = Array.isArray(section.productIds) ? section.productIds.map(Number) : [];
    const categoryIds = new Set((section.categoryIds || []).map(Number));
    const categoryNames = new Set((section.categories || []).map(item => String(item || '').toLowerCase()));

    let list = [];
    
    if (manualIds.length > 0) {
        if (options.productsById) {
            list = manualIds.map(id => options.productsById.get(id)).filter(Boolean);
        } else {
            const productMap = new Map(allProducts.map(p => [Number(p.id), p]));
            list = manualIds.map(id => productMap.get(id)).filter(Boolean);
        }
    } else if (source === 'featured') {
        list = options.featuredProducts || allProducts.slice(0, 8);
    } else if (source === 'new-arrivals' || source === 'new_arrivals') {
        list = options.newArrivalProducts || [...allProducts].reverse().slice(0, 8);
    } else if (source === 'trending') {
        list = options.bestSellerProducts || [...allProducts].sort((a, b) => {
            const aSold = Number(a?.soldCount || a?.salesCount || a?.orderCount || 0);
            const bSold = Number(b?.soldCount || b?.salesCount || b?.orderCount || 0);
            if (aSold !== bSold) return bSold - aSold;
            return Number(b?.price || 0) - Number(a?.price || 0);
        }).slice(0, 8);
    } else if (source === 'flash-sale' || source === 'flash_sale') {
        list = options.flashSaleProducts || allProducts.filter(p => Number(p.compareAtPrice || 0) > Number(p.price || 0)).slice(0, 8);
    } else if (source === 'recently-viewed' || source === 'recently_viewed') {
        list = options.recentlyViewedProducts || []; 
    } else {
        list = (options.recommendedProducts && options.recommendedProducts.length > 0) ? options.recommendedProducts : allProducts;
    }

    if (categoryIds.size > 0 || categoryNames.size > 0) {
        list = list.filter(item => {
            const itemCategoryId = Number(item.categoryId || item.category?.id || 0);
            const itemCategoryName = options.productCategoryNamesById 
                ? options.productCategoryNamesById.get(Number(item.id)) || ''
                : String(item.categoryName || item.category || '').toLowerCase();
            return categoryIds.has(itemCategoryId) || categoryNames.has(itemCategoryName);
        });
    }

    const configuredLimit = Number(section.productLimit) || 8;
    const effectiveLimit = Math.max(configuredLimit, 8);

    // Backfill from allProducts when a homepage showcase row has fewer than 8 items
    // and no strict category filter is applied, preventing half-empty horizontal rows on desktop.
    if (
        list.length > 0 &&
        list.length < Math.min(8, allProducts.length) &&
        categoryIds.size === 0 &&
        categoryNames.size === 0 &&
        source !== 'recently-viewed' &&
        source !== 'recently_viewed'
    ) {
        const seenIds = new Set(list.map(item => Number(item?.id)));
        const extras = allProducts.filter(item => item && !seenIds.has(Number(item.id)));
        list = [...list, ...extras];
    }

    return list.slice(0, effectiveLimit);
};

export const resolveSectionCategories = (section, allCategories = [], options = {}) => {
    if (!section) return [];
    const ids = new Set((section.categoryIds || []).map(Number));
    const names = new Set((section.categories || []).map(item => String(item || '').toLowerCase()));
    
    if (ids.size === 0 && names.size === 0) {
        return options.categoryCircles || allCategories.slice(0, section.productLimit || 12);
    }
    
    return allCategories.filter(cat => ids.has(Number(cat.id)) || names.has(String(cat.name || '').toLowerCase()));
};

export const resolveSectionVideos = (section, allVideos = [], options = {}) => {
    if (!section) return [];
    const ids = Array.isArray(section.videoIds) ? section.videoIds.map(Number) : [];
    
    if (ids.length > 0) {
        if (options.videosById) {
            return ids.map(id => options.videosById.get(id)).filter(Boolean);
        } else {
            const videoMap = new Map(allVideos.map(v => [Number(v.id), v]));
            return ids.map(id => videoMap.get(id)).filter(Boolean);
        }
    }
    
    return allVideos;
};
